export default __webpack_public_path__ + "static/media/emoji.125b7e28.png";